export default {
  refreshCache: 'Làm mới bộ nhớ đệm',
  confirm: 'xác nhận',
  cancel: ' Hủy',
  success: 'Thành công',
  error: 'Thất bại',
  del: ' xóa',
  search: ' tìm kiếm',
  detail: ' chi tiết',
  editor: ' Sửa',
  empty: ' bỏ trống',
  login: 'đăng nhập',
  emptyValue: 'Giá trị rỗng',
  add: ' thêm',
  export: ' xuất excel',
  hint: ' hiển thị',
  transferAmount: 'Chuyển hạn ngạch',
  withdraw: 'rút tiền',
  review: 'chờ duyệt',
  pass: 'thông qua',
  reject: 'từ chối',
  next: 'bước tiếp theo',
  recharge: 'Nạp điện',
  start: 'Kích hoạt',
  start1: 'Mở tự động làm mới trang',
  stop: 'Hủy kích hoạt',
  stop1: 'Đóng tự động làm mới trang',
  manual: 'Bù đơn',
  callback: 'Gọi lại',
  submit: 'Đệ trình',
  withdrawLimit: 'Sửa đổi giới hạn rút tiền theo đợt',
  update: 'Ôn lại',
  withdrawMax: 'Giới hạn rút tiền',
  allOlder: 'Bổ sung đơn hàng hàng loạt',
  qrCode: 'mã QR',
  取消出款: 'Hủy bỏ rút tiền',
  出款成功: 'Rút tiền thành công'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/btns.js